module.exports = __webpack_public_path__ + "static/media/shuttlecock.9d1a8b4e.svg";